import React from 'react'

const IconSvg = () => (
  <svg
    width='50'
    height='50'
    viewBox='0 0 50 50'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g opacity='0.25'>
      <path
        d='M32.2917 29.1667H30.6458L30.0625 28.6042C32.1042 26.2292 33.3333 23.1458 33.3333 19.7917C33.3333 12.3125 27.2708 6.25 19.7917 6.25C12.3125 6.25 6.25 12.3125 6.25 19.7917C6.25 27.2708 12.3125 33.3333 19.7917 33.3333C23.1458 33.3333 26.2292 32.1042 28.6042 30.0625L29.1667 30.6458V32.2917L39.5833 42.6875L42.6875 39.5833L32.2917 29.1667ZM19.7917 29.1667C14.6042 29.1667 10.4167 24.9792 10.4167 19.7917C10.4167 14.6042 14.6042 10.4167 19.7917 10.4167C24.9792 10.4167 29.1667 14.6042 29.1667 19.7917C29.1667 24.9792 24.9792 29.1667 19.7917 29.1667Z'
        fill='#1B1B1D'
      />
    </g>
  </svg>
)

export default IconSvg
